export default __webpack_public_path__ + "static/media/ProductSans-Medium.c1544ac0.woff2";